var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["macros/date-macro.j2"] = require( "macros/date-macro.j2" );
dependencies["contentful/render-modules.j2"] = require( "contentful/render-modules.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/generic-email-service.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
env.getTemplate("macros/form-validation.j2", false, "core/templates/generic-email-service.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_4 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_4);
if(t_1.hasOwnProperty("hasErrors")) {
var t_5 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_5);
if(t_1.hasOwnProperty("validatedField")) {
var t_6 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_6);
if(t_1.hasOwnProperty("nonRequiredValidatedField")) {
var t_7 = t_1.nonRequiredValidatedField;
} else {
cb(new Error("cannot import 'nonRequiredValidatedField'")); return;
}
context.setVariable("nonRequiredValidatedField", t_7);
output += "\n";
env.getTemplate("macros/date-macro.j2", false, "core/templates/generic-email-service.j2", false, function(t_9,t_8) {
if(t_9) { cb(t_9); return; }
t_8.getExported(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
if(t_8.hasOwnProperty("dayOptions")) {
var t_11 = t_8.dayOptions;
} else {
cb(new Error("cannot import 'dayOptions'")); return;
}
context.setVariable("dayOptions", t_11);
if(t_8.hasOwnProperty("monthOptions")) {
var t_12 = t_8.monthOptions;
} else {
cb(new Error("cannot import 'monthOptions'")); return;
}
context.setVariable("monthOptions", t_12);
output += "\n\n<div class=\"dom-generic-email-service\">\n    ";
var t_13;
t_13 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),runtime.contextOrFrameLookup(context, frame, "form_slug"));
frame.set("emailFormConfig", t_13, true);
if(frame.topLevel) {
context.setVariable("emailFormConfig", t_13);
}
if(frame.topLevel) {
context.addExport("emailFormConfig", t_13);
}
output += "\n\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"state") == "submitted" && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFormConfig")),"successModules") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"error")) {
output += "\n        ";
var t_14;
t_14 = runtime.contextOrFrameLookup(context, frame, "None");
frame.set("data", t_14, true);
if(frame.topLevel) {
context.setVariable("data", t_14);
}
if(frame.topLevel) {
context.addExport("data", t_14);
}
output += "\n        ";
var t_15;
t_15 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFormConfig")),"successModules");
frame.set("modules", t_15, true);
if(frame.topLevel) {
context.setVariable("modules", t_15);
}
if(frame.topLevel) {
context.addExport("modules", t_15);
}
output += "\n        ";
env.getTemplate("contentful/render-modules.j2", false, "core/templates/generic-email-service.j2", null, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
t_16.render(context.getVariables(), frame, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
output += t_17
})});
}
else {
output += "<form novalidate data-form-slug=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "form_slug"), env.opts.autoescape);
output += "\" data-parsley-validate action=\"#\" method=\"post\" class=\"c-form js-generic-email-form\">\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFormConfig")),"brandCode") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFormConfig")),"eid") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFormConfig")),"sendToEmail")) {
output += "\n                ";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("form_fields"))(env, context, frame, runtime, function(t_21,t_20) {
if(t_21) { cb(t_21); return; }
output += t_20;
output += "\n            ";
});
}
else {
output += "\n                <div class=\"o-row\">\n                    <div class=\"o-column o-extra-small--12\">\n                        <div class=\"c-form__field has-error\">\n                            <div class=\"c-form-block\">\n                                <p class=\"c-form-block__p\">\n                                    ";
output += runtime.suppressValue((lineno = 21, colno = 53, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "errorTranslation"), "errorTranslation", context, ["GENERIC_EMAIL_CONFIG_ERROR"])), env.opts.autoescape);
output += "\n                                </p>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            ";
;
}
output += "\n        </form>\n    ";
;
}
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_form_fields(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_form_fields: b_form_fields,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/generic-email-service.j2"] , dependencies)